<template>
  <span class="nuxt-link text-caption" @click="isRecallDialogOpen = true">
    {{ 'Vertrag widerrufen' }}
  </span>

  <v-dialog v-model="isRecallDialogOpen" max-width="800">
    <v-card>
      <div class="header text-white">
        <v-card-title class="text-h6 pt-6 px-6">Widerruf bestellte Dienstleistung</v-card-title>
        <v-card-text v-show="!recallSubmitMessage" class="px-6">
          Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über die Erbringung der
          folgenden Dienstleistung.
        </v-card-text>
      </div>
      <v-card-text class="px-6">
        <v-row>
          <v-col v-if="!recallSubmitMessage" cols="12">
            <v-form ref="recallFormRef" @submit.prevent="handleRecallSubmit">
              <v-row>
                <v-col cols="12" class="text-text-lighten text-uppercase pb-0 text-body-small">
                  Persönliche Daten
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="recallForm.name"
                    placeholder="Max Mustermann"
                    persistent-placeholder
                    variant="outlined"
                    density="comfortable"
                    autocomplete="name"
                    :rules="nameRules"
                    required>
                    <template #label>
                      Vor- und Nachname
                      <span class="text-primary-dark">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="recallForm.address"
                    placeholder="Musterstraße 1, 12345 Musterstadt"
                    persistent-placeholder
                    variant="outlined"
                    density="comfortable"
                    autocomplete="address"
                    :rules="addressRules"
                    required>
                    <template #label>
                      Anschrift
                      <span class="text-primary-dark">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="recallForm.email"
                    placeholder="max.mustermann@example.com"
                    type="email"
                    persistent-placeholder
                    variant="outlined"
                    density="comfortable"
                    autocomplete="email"
                    :rules="emailRules"
                    required>
                    <template #label>
                      E-Mail
                      <span class="text-primary-dark">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="recallForm.phone"
                    label="Telefonnummer"
                    placeholder="+49 123 4567890"
                    type="tel"
                    persistent-placeholder
                    variant="outlined"
                    density="comfortable"
                    autocomplete="tel" />
                </v-col>

                <v-col cols="12" class="py-2">
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  class="text-text-lighten text-uppercase pb-0 font-weight-medium text-body-small">
                  Vertragsdetails
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="recallForm.receiptId"
                    variant="outlined"
                    placeholder="VNR-000000"
                    persistent-placeholder
                    density="comfortable"
                    autocomplete="off"
                    :rules="receiptIdRules"
                    required>
                    <template #label>
                      Vereinbarungsnummer
                      <span class="text-primary-dark">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-date-input
                    v-model="recallForm.receiptDate"
                    variant="outlined"
                    placeholder="TT.MM.JJJJ"
                    persistent-placeholder
                    density="comfortable"
                    max-width="368"
                    :max="today"
                    label="Bestelldatum" />
                </v-col>

                <v-col cols="12" class="py-2">
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  class="text-text-lighten text-uppercase pb-0 font-weight-medium text-body-small">
                  Bestätigungen
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-card variant="tonal" class="consent-card">
                    <v-checkbox
                      v-model="recallForm.checkboxRecall"
                      :rules="checkboxRules"
                      required
                      :center-affix="false">
                      <template #label>
                        <div>
                          Ich akzeptiere, dass das Widerrufsrecht vor Ablauf der Widerrufsfrist
                          entfällt, wenn die Dienstleistung vollständig in Anspruch genommen wurde.
                        </div>
                      </template>
                    </v-checkbox>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card variant="tonal" class="consent-card">
                    <v-checkbox
                      v-model="recallForm.checkboxPrivacyPolicy"
                      :rules="checkboxRules"
                      required
                      :center-affix="false">
                      <template #label>
                        <div>
                          Ich erkläre mich mit den

                          <NuxtLink
                            to="/datenschutzerklaerung"
                            target="_blank"
                            rel="noopener"
                            class="text-primary-dark">
                            Datenschutzbestimmungen
                          </NuxtLink>
                          und
                          <NuxtLink
                            to="/agb"
                            target="_blank"
                            rel="noopener"
                            class="text-primary-dark">
                            AGB
                          </NuxtLink>
                          einverstanden.
                        </div>
                      </template>
                    </v-checkbox>
                  </v-card>
                </v-col>

                <!-- Hidden honeypot to trap basic bots. -->

                <div class="sr-only" aria-hidden="true">
                  <label for="recallWebsite" class="text-surface">Website</label>
                  <input
                    id="recallWebsite"
                    v-model="recallForm.website"
                    name="website"
                    tabindex="-1"
                    autocomplete="off" />
                </div>

                <v-row>
                  <v-col cols="6">
                    <button-primary @click="isRecallDialogOpen = false">Abbrechen</button-primary>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <button-primary color="primary" type="submit" :loading="isRecallSubmitting">
                      Widerruf übermitteln
                    </button-primary>
                  </v-col>
                </v-row>
              </v-row>
            </v-form>
          </v-col>

          <v-col v-else cols="12" class="d-flex flex-column align-center">
            <v-alert type="success" variant="tonal" class="mt-2 w-100">
              {{ recallSubmitMessage }}
              <br />
              <strong>Beleg-ID:</strong>
              {{ receiptId }}
            </v-alert>
            <button-secondary class="mt-4" @click="isRecallDialogOpen = false">
              Schließen
            </button-secondary>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
const { sendRecall } = useApiWrapper()
const { isEmailValidated } = useValidation()
const generateSecureRandom = (max: number): number => {
  const array = new Uint32Array(1)
  window.crypto.getRandomValues(array)
  return (array[0] % (max * 10000)) / 10000
}
const minRecallSubmitTimeMs = ref(3000)
const formSessionId = ref('')

onMounted(() => {
  minRecallSubmitTimeMs.value = 3000 + generateSecureRandom(1000)
  formSessionId.value = `${Date.now()}-${generateSecureSessionId()}`
})
const MIN_SUBMIT_INTERVAL_MS = 5000
const MAX_SUBMISSION_ATTEMPTS = 3
const MAX_FIELD_LENGTH = {
  name: 100,
  email: 254,
  receiptId: 50,
  phone: 20,
}

const generateSecureSessionId = () => {
  const array = new Uint8Array(12)
  crypto.getRandomValues(array)
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('')
}

const isRecallDialogOpen = ref(false)
const isRecallSubmitting = ref(false)
const recallSubmitMessage = ref('')
const recallFirstInputAt = ref(0)
const lastSubmissionTime = ref(0)
const submissionAttempts = ref(0)

const recallFormRef = ref()
const recallForm = reactive({
  name: '',
  email: '',
  phone: '',
  address: '',
  receiptId: '',
  receiptDate: '',
  checkboxRecall: false,
  checkboxPrivacyPolicy: false,
  website: '',
  company: '',
  phone_alt: '',
})
const receiptId = ref('')

const today = computed(() => {
  const date = new Date()
  return date.toISOString().split('T')[0]
})

const nameRules = [(v: string) => !!v?.trim() || 'Bitte geben Sie Ihren Namen ein.']
const emailRules = [
  (v: string) => !!v?.trim() || 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
  (v: string) => (isEmailValidated(v) ?? '') || 'Bitte geben Sie eine gueltige E-Mail-Adresse ein.',
]
const addressRules = [(v: string) => !!v?.trim() || 'Bitte geben Sie Ihre Adresse ein.']
const receiptIdRules = [(v: string) => !!v?.trim() || 'Bitte geben Sie Ihre Beleg-ID ein.']
const checkboxRules = [
  (v: boolean) => v || 'Bitte akzeptieren Sie diese Bedingung, um fortzufahren.',
]

watch(isRecallDialogOpen, isOpen => {
  if (!isOpen) {
    recallSubmitMessage.value = ''
    recallFirstInputAt.value = 0
    return
  }

  recallSubmitMessage.value = ''
  recallFirstInputAt.value = 0
})

watch(
  () => [recallForm.name, recallForm.email, recallForm.receiptId, recallForm.receiptDate],
  values => {
    if (recallFirstInputAt.value) return
    if (
      values.some(value => {
        if (typeof value === 'string') return value.trim().length > 0
        return Boolean(value)
      })
    ) {
      recallFirstInputAt.value = Date.now()
    }
  },
)

function resetRecallForm() {
  recallForm.name = ''
  recallForm.email = ''
  recallForm.phone = ''
  recallForm.receiptId = ''
  recallForm.receiptDate = ''
  recallForm.website = ''
  recallForm.address = ''
  recallForm.company = ''
  recallForm.phone_alt = ''
  recallFirstInputAt.value = 0
  recallForm.checkboxRecall = false
  recallForm.checkboxPrivacyPolicy = false
}

async function handleRecallSubmit() {
  const validationResult = await recallFormRef.value?.validate()
  if (!validationResult?.valid) return

  const now = Date.now()
  if (submissionAttempts.value >= MAX_SUBMISSION_ATTEMPTS) {
    recallSubmitMessage.value = 'Zu viele Anfragen. Bitte versuchen Sie es spaeter erneut.'
    return
  }

  if (lastSubmissionTime.value && now - lastSubmissionTime.value < MIN_SUBMIT_INTERVAL_MS) {
    recallSubmitMessage.value = 'Bitte warten Sie kurz, bevor Sie erneut absenden.'
    return
  }

  if (
    recallForm.name.length > MAX_FIELD_LENGTH.name ||
    recallForm.email.length > MAX_FIELD_LENGTH.email ||
    recallForm.receiptId.length > MAX_FIELD_LENGTH.receiptId ||
    recallForm.phone.length > MAX_FIELD_LENGTH.phone
  ) {
    recallSubmitMessage.value = 'Ein oder mehrere Felder sind zu lang.'
    return
  }

  const noUserInputTimestamp = recallFirstInputAt.value === 0
  const filledTooFast =
    !noUserInputTimestamp && Date.now() - recallFirstInputAt.value < minRecallSubmitTimeMs.value
  const isBot =
    Boolean(
      recallForm.website.trim() || recallForm.company.trim() || recallForm.phone_alt.trim(),
    ) ||
    noUserInputTimestamp ||
    filledTooFast

  if (isBot) {
    recallSubmitMessage.value = 'Vielen Dank. Ihre Anfrage wird geprueft.'
    return
  }

  isRecallSubmitting.value = true
  try {
    submissionAttempts.value += 1
    lastSubmissionTime.value = now
    receiptId.value = recallForm.receiptId
    await sendRecall({
      name: recallForm.name,
      email: recallForm.email,
      phone: recallForm.phone,
      address: recallForm.address,
      receiptId: recallForm.receiptId,
      receiptDate: String(recallForm.receiptDate ?? ''),
      checkboxRecall: recallForm.checkboxRecall,
      checkboxPrivacyPolicy: recallForm.checkboxPrivacyPolicy,
      website: recallForm.website,
      company: recallForm.company,
      phone_alt: recallForm.phone_alt,
      sessionId: formSessionId.value,
      firstInputAt: recallFirstInputAt.value,
      timestamp: now,
    })
    recallSubmitMessage.value =
      'Vielen Dank für deine Nachricht! Die E-Mail-Bestätigung ist unterwegs.'
    resetRecallForm()
    recallFormRef.value?.resetValidation()
  } finally {
    isRecallSubmitting.value = false
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: #00b18f;
}
:deep(.v-input__details) {
  display: contents;
}
:deep(.v-messages) {
  display: none;
}
:deep(.v-checkbox .v-label) {
  font-size: 12px;
  font-weight: 200;
}
.nuxt-link {
  font-weight: 600;
  color: rgb(177, 20, 20) !important;
  cursor: pointer;
  text-decoration: underline;
}
:deep(.text-primary-dark) {
  color: #00b18f !important;
}
:deep(.text-body-small) {
  font-size: 12px !important;
  font-weight: bold !important;
}
:deep(.consent-card) {
  background: #f9fafc !important;
  border: 1px solid #cfd8e6 !important;
  .v-card__underlay {
    background: none !important;
  }
}
</style>
